// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg_aws[data-v-4551dae0]{background-size:cover;background-position:50%;background-image:url(/img/partners/bg_convertirme_partner.png)!important}.my_divider[data-v-4551dae0]{border:3px solid;border-radius:2px;max-width:5rem;width:40px}", ""]);
// Exports
module.exports = exports;
